module.exports = __webpack_public_path__ + "img/image-man-texting.02f900e1.jpg";